import { type UserDocument } from '@hooks/use-ocr.hooks.ts'
import { useApi } from '@hooks/use-api-requests.hook'

export function useDocumentsAvailable() {
	const [documents, triggerFetchDocuments, isFetchingDocuments] = useApi<
		Array<UserDocument>
	>({
		request: 'DbOperations/GetDocumentsUploadStatus',
		method: 'POST',
		shouldCache: false,
	})

	return {
		documents,
		isFetchingDocuments,
		triggerFetchDocuments,
	}
}
